import { render, staticRenderFns } from "./EditorModal.vue?vue&type=template&id=1ca057c8&scoped=true&"
import script from "./EditorModal.vue?vue&type=script&lang=js&"
export * from "./EditorModal.vue?vue&type=script&lang=js&"
import style0 from "./EditorModal.vue?vue&type=style&index=0&id=1ca057c8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ca057c8",
  null
  
)

export default component.exports